import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-arch-runtime',
	templateUrl:'./RuntimePage.html',
	styles: [],
	styleUrls:['./RuntimePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		WaCardDirective,
],
	standalone:true
})
export class RuntimePage
{
}
